/* Store Ec · X13 — utilidades compartidas: aparición suave y compra rápida */
(function(){
  document.documentElement.classList.add('x13-js');
  function aparecer(){
    var els=document.querySelectorAll('[data-x13-aparece]:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target)}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  // red de seguridad: nada queda oculto aunque falle el observador
  setTimeout(function(){document.querySelectorAll('[data-x13-aparece]').forEach(function(e){e.classList.add('is-in')})},2500);
  document.addEventListener('DOMContentLoaded',aparecer);
  document.addEventListener('shopify:section:load',aparecer);

  window.X13=window.X13||{};

  // Agrega al carrito y abre el carrito lateral del tema; si no existe, va a /cart
  window.X13.comprar=function(variantId,cantidad,boton){
    var drawer=document.querySelector('cart-drawer');
    if(boton){boton.disabled=true;boton.setAttribute('aria-busy','true')}
    var body={items:[{id:Number(variantId),quantity:Number(cantidad)||1}]};
    if(drawer&&drawer.getSectionsToRender){
      body.sections=drawer.getSectionsToRender().map(function(s){return s.id});
      body.sections_url=window.location.pathname;
    }
    var url=(window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js';
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json()})
      .then(function(res){
        if(res.status){throw new Error(res.description||res.message)}
        if(drawer&&drawer.renderContents&&res.sections){
          var item=res.items&&res.items[0]?res.items[0]:{};
          item.sections=res.sections;
          if(drawer.classList.contains('is-empty'))drawer.classList.remove('is-empty');
          drawer.renderContents(item);
        } else {
          window.location.href=(window.routes&&window.routes.cart_url)||'/cart';
        }
      })
      .catch(function(e){aviso(boton,e.message||'No se pudo agregar. Intenta de nuevo.')})
      .finally(function(){if(boton){boton.disabled=false;boton.removeAttribute('aria-busy')}});
  };

  // Cambia la cantidad de una línea del carrito (venta adicional del carrito)
  window.X13.cambiarCantidad=function(variantId,cantidad){
    var u={};u[variantId]=cantidad;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})})
      .then(function(){window.location.reload()});
  };

  function aviso(boton,msg){
    var p=document.createElement('p');
    p.setAttribute('role','alert');
    p.textContent=msg;
    p.style.cssText='margin:10px 0 0;font:500 14px/1.4 Inter,sans-serif;color:#B42318';
    if(boton&&boton.parentNode){boton.parentNode.insertBefore(p,boton.nextSibling);setTimeout(function(){p.remove()},6000)}
  }
})();
